import dynamic from "next/dynamic";
const FeaturesTablePricingComponent = dynamic(()=>import("./features-table-pricing-component"));
import FeaturesTablePricingConfig from "./features-table-pricing-config";
import FeaturesTablePricingAdvancedConfig from "./features-table-pricing-advanced-config";
export default {
    FeaturesTablePricingComponent,
    FeaturesTablePricingConfig,
    FeaturesTablePricingAdvancedConfig
};
